import React from 'react';
import { homeObjBlog1, homeObjBlog2, homeObjBlog3, homeObjOne, homeObjTwo, homeObjThree, homeObjFour ,
  maindata,
  maindata2,
  maindata3,
 } from './Data';
import { InfoSection } from '../../components';

function Blog() {
  return (
    <>
      <InfoSection {...homeObjBlog1} />
      <InfoSection {...homeObjBlog2} />
      <InfoSection {...homeObjBlog3} />
      <InfoSection {...homeObjFour} />
      <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjTwo} />
      <InfoSection {...maindata} />
      <InfoSection {...maindata2} />
      <InfoSection {...maindata3} />
    </>
  );
}

export default Blog;
